/**
 * 用户相关API
 * 参照xht-web项目的API接口
 */
import request from '@/utils/request'

/**
 * 获取用户信息
 * 使用与xht-web相同的接口
 * @returns {Promise} 返回用户信息
 */
export function getUserInfo() {
  return request({
    url: '/uic/users/get',
    method: 'get',
    headers: {
      'Content-Type': 'application/json;charset=UTF-8'
    }
  })
}

/**
 * 更新用户信息
 * @param {Object} userInfo - 用户信息
 * @returns {Promise} 返回更新结果
 */
export function updateUserInfo(userInfo) {
  return request({
    url: '/uic/users/update',
    method: 'post',
    data: userInfo
  })
}

/**
 * 更新用户手机号
 * @param {Object} phoneData - 手机号数据 { phone: '手机号' }
 * @returns {Promise} 返回更新结果
 */
export function updatePhone(phoneData) {
  return request({
    url: '/uic/users/update',
    method: 'post',
    data: phoneData
  })
}

/**
 * 获取用户余额
 * @returns {Promise} 返回用户余额
 */
export function getUserBalance() {
  return request({
    url: '/uic/user/balance',
    method: 'get'
  })
}

/**
 * 更新用户密码
 * @param {Object} passwordData - 密码数据 { password: '新密码', username: '用户名' }
 * @returns {Promise} 返回更新结果
 */
export function updatePassword(passwordData) {
  return request({
    url: '/uic/users/update-credentials',
    method: 'post',
    data: passwordData
  })
}

/**
 * 通过微信授权code获取openid（静默授权）
 * @param {string} code - 微信授权code
 * @param {string} accountType - 账号类型：DEFAULT、XHT_PUBLIC、HZ，默认为XHT_PUBLIC（对应XHT-TEST）
 * @returns {Promise} 返回openid
 */
export function getWxOpenIdByCode(code, accountType = 'XHT_PUBLIC') {
  console.log('============== [API] getWxOpenIdByCode 开始 ==============')
  console.log('📝 [API] 请求参数:', { 
    code: code?.substring(0, 10) + '...', 
    accountType: accountType,
    '说明': accountType === 'XHT_PUBLIC' ? '使用XHT-TEST的appId和appSecret' : 
            accountType === 'HZ' ? '使用HZ的appId和appSecret' : '使用DEFAULT的appId和appSecret'
  })
  console.log('📝 [API] 请求URL: /uic/wx/openid')
  console.log('📝 [API] 完整请求URL:', `/uic/wx/openid?code=${encodeURIComponent(code)}&accountType=${accountType}`)
  
  return request({
    url: `/uic/wx/openid?code=${encodeURIComponent(code)}&accountType=${accountType}`,
    method: 'get'
  }).then(response => {
    console.log('✅ [API] getWxOpenIdByCode 响应成功')
    console.log('📝 [API] 响应数据:', response)
    console.log('📝 [API] response.data:', response?.data)
    console.log('============== [API] getWxOpenIdByCode 完成 ==============')
    return response
  }).catch(error => {
    console.error('❌ [API] getWxOpenIdByCode 请求失败:', error)
    console.error('  - 错误消息:', error.message)
    throw error
  })
}

/**
 * 绑定微信OpenId到当前用户
 * @param {string} wxOpenId - 微信OpenId
 * @returns {Promise} 返回更新结果
 */
export function bindWxOpenId(wxOpenId) {
  console.log('============== [API] bindWxOpenId 开始 ==============')
  console.log('📝 [API] 请求参数:', { wxOpenId })
  console.log('📝 [API] 请求URL: /uic/users/wx/bind')
  console.log('📝 [API] 请求方法: POST')
  
  return request({
    url: '/uic/users/wx/bind',
    method: 'post',
    data: { wxOpenId }
  }).then(response => {
    console.log('✅ [API] bindWxOpenId 响应成功')
    console.log('📝 [API] 响应数据:', response)
    console.log('============== [API] bindWxOpenId 完成 ==============')
    return response
  }).catch(error => {
    console.error('❌ [API] bindWxOpenId 请求失败:', error)
    console.error('  - 错误消息:', error.message)
    console.error('  - 错误响应:', error.response)
    throw error
  })
}

/**
 * 获取微信配置信息（appId等，不包含secret）
 * @param {string} accountType - 账号类型：DEFAULT、XHT_PUBLIC、HZ，默认为XHT_PUBLIC
 * @returns {Promise} 返回微信配置信息
 */
export function getWxConfig(accountType = 'XHT_PUBLIC') {
  return request({
    url: `/uic/wx/config?accountType=${accountType}`,
    method: 'get'
  })
}

/**
 * 获取微信授权链接（通过后端生成，确保使用正确的配置）
 * @param {string} redirectUri - 授权后重定向的回调链接地址
 * @param {string} accountType - 账号类型：DEFAULT、XHT_PUBLIC、HZ，默认为XHT_PUBLIC
 * @param {boolean} silentAuth - 是否静默授权（true: snsapi_base, false: snsapi_userinfo），默认为true
 * @param {string} state - 可选，state参数
 * @returns {Promise} 返回授权链接
 */
export function getWxAuthUrl(redirectUri, accountType = 'XHT_PUBLIC', silentAuth = true, state = null) {
  return request({
    url: '/uic/wx/auth/url',
    method: 'post',
    data: {
      accountType,
      redirectUri,
      silentAuth,
      state,
      forcePopup: false
    }
  })
}